.container {
  flex: 1;
}

.emptyText {
  padding: 16px;
  color: var(--tuna-palette-action-disabled);
}
